import React from 'react';
import { AddOn } from './Info/AddOn';
import { usePermissionModal } from '$/components/Permission';
import { StripeLoader } from '$/components/StripeLoader';

export enum UpdateAddOnType {
  Subscribe = 'Subscribe',
  Unsubscribe = 'Unsubscribe',
  Resubscribe = 'Resubscribe',
}

export interface UpdateAddOnModalState {
  type: UpdateAddOnType;
  addOn: AddOn;
  tierId: string;
  onAddSuccess?: () => void;
}

export interface WithAddOnProps {
  className?: string;
  onAddSuccess?: () => void;
  children: (props: {
    isAvailable: boolean;
    isModalOpen: boolean;
    ManageLink: React.ReactElement;
    onAdd: () => void;
  }) => React.ReactNode;
}

export interface AddOnsContextValue {
  isModalOpen: boolean;
  modal: UpdateAddOnModalState | null;
  closeModal: () => void;
  openModal: (state: UpdateAddOnModalState) => void;
}
export const AddOnsContext = React.createContext<AddOnsContextValue>({} as AddOnsContextValue);
export const useAddOnsContext = (): AddOnsContextValue => React.useContext(AddOnsContext);

export const AddOnProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [modal, setModal] = React.useState<UpdateAddOnModalState | null>(null);
  const { isModalOpen } = usePermissionModal();
  const openModal = React.useCallback((modal: UpdateAddOnModalState): void => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback((): void => {
    setModal(null);
  }, []);
  const value: AddOnsContextValue = {
    modal,
    openModal,
    closeModal,
    isModalOpen: Boolean(modal) || isModalOpen,
  };
  return (
    <StripeLoader>
      <AddOnsContext.Provider value={value}>{children}</AddOnsContext.Provider>
    </StripeLoader>
  );
};
